import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { getDateTimeLocale } from 'i18n/dateTimeInternationalization';

interface FormattedDateWithTimezoneProps {
  getValue: () => Date | undefined | null;
}

const FormattedDateWithTimezone = ({
  getValue,
}: FormattedDateWithTimezoneProps) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const date = getValue();

  if (!date) {
    return t('common.notApplicable');
  }

  return format(date, 'PPppp', { locale: getDateTimeLocale(language) });
};

export default FormattedDateWithTimezone;
